// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/Cooperate.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Carousel {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 90%;
  margin: auto;
  padding: 30px 0;
}
.Carousel h2 {
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 40px;
  text-align: center;
  color: #FFFFFF;
}
.Carousel p {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  max-width: 700px;
  margin: auto;
  padding-bottom: 30px;
}
.Carousel .CarouselBox {
  display: flex;
  justify-content: center;
  width: 70%;
  margin: auto;
}
@media (max-width: 790px) {
  .Carousel .CarouselBox {
    width: 80%;
    margin: 0;
  }
}
.Carousel .CarouselBox div {
  display: flex;
  width: 297px;
  height: 400px;
}
@media (max-width: 790px) {
  .Carousel .CarouselBox div {
    justify-content: center;
    width: 150px;
    height: 220px;
  }
}
.Carousel .CarouselBox img {
  border: 2px solid #FFFFFF;
  border-radius: 24px;
  background-color: #000000;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.Carousel .filter {
  filter: blur(12.5px);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@media (max-width: 790px) {
  .Carousel {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/3dSlider/style.scss"],"names":[],"mappings":"AAAA;EACI,mDAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AACJ;AACI;EACI,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AACR;AAEI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;AAAR;AAGI;EACI,aAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;AADR;AAEQ;EALJ;IAMQ,UAAA;IACA,SAAA;EACV;AACF;AAAQ;EACI,aAAA;EACA,YAAA;EACA,aAAA;AAEZ;AADY;EAJJ;IAKQ,uBAAA;IACA,YAAA;IACA,aAAA;EAId;AACF;AAFQ;EACI,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAIZ;AAEI;EACI,oBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAAR;AAEI;EArEJ;IAsEQ,WAAA;EACN;AACF","sourcesContent":[".Carousel {\n    background: url(\"../../Assets/Images/Cooperate.png\");\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    width: 90%;\n    margin: auto;\n    padding: 30px 0;\n\n    h2 {\n        font-family: 'hemi_head';\n        font-style: italic;\n        font-weight: 400;\n        font-size: 40px;\n        text-align: center;\n        color: #FFFFFF;\n    }\n\n    p {\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        text-align: center;\n        color: rgba(255, 255, 255, 0.7);\n        max-width: 700px;\n        margin: auto;\n        padding-bottom: 30px;\n    }\n\n    .CarouselBox {\n        display: flex;\n        justify-content: center;\n        width: 70%;\n        margin: auto;\n        @media (max-width: 790px) {\n            width: 80%;\n            margin: 0;\n        }\n        div{\n            display: flex;\n            width: 297px;\n            height: 400px;\n            @media (max-width: 790px) {\n                justify-content: center;\n                width: 150px;\n                height: 220px;\n            }\n        }\n        img{\n            border: 2px solid #FFFFFF;\n            border-radius: 24px;\n            background-color: #000000;\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n            @media (max-width: 790px) {\n                //width: 150px;\n            }\n        }\n    }\n    .filter{\n        filter: blur(12.5px);\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n    }\n    @media (max-width: 790px) {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
